/* ============================================================
   My Social Book — Order Tracking  (vanilla, no dependencies)
   Renders the /pages/tracking module: lookup form, loading,
   result (status hero + 5-stage stepper + event timeline +
   carrier block) and error states.

   Reads config from data-* attributes on #msb-track and calls
   the MAK endpoint:  GET {endpoint}?tracking_number=XXXX
   Expected JSON response shape is documented in README.md.
   ============================================================ */
(function () {
  "use strict";
  var root = document.getElementById("msb-track");
  if (!root) return;

  /* ---------- config from Liquid (data-* attributes) ---------- */
  var CFG = {
    endpoint:  root.dataset.endpoint || "",
    apiKey:    root.dataset.apiKey || "",
    demo:      root.dataset.demo === "true",
    heading:   root.dataset.heading || "Track your order",
    sub:       root.dataset.sub || "Enter your tracking number to see exactly where your book is.",
    helper:    root.dataset.helper || "It's in your shipping confirmation email from My Social Book \u2014 a 12\u201322 digit number next to the carrier name.",
    supportUrl: root.dataset.supportUrl || "/pages/contact",
    xsell:     root.dataset.xsell === "true",
    xsellH:    root.dataset.xsellHeading || "Loved this one?",
    xsellP:    root.dataset.xsellText || "Turn your latest memories into your next book.",
    xsellBtn:  root.dataset.xsellButton || "Create another book",
    xsellUrl:  root.dataset.xsellUrl || "/",
  };

  /* Optional order code carried by the email link (?order=MB582918). The API
     does not know the merchant order number, so the shipping email supplies it.
     Empty when the visitor types a number by hand — falls back to the tracking number. */
  var URL_ORDER = "";

  /* Optional destination from the email link (?cc=NL&pc=1000AA) for carriers that
     require country + postal code (e.g. PostNL). Empty for manual lookups, in which
     case the "needs postal" prompt collects them. */
  var URL_CC = "";
  var URL_PC = "";

  /* ---------- stage model ---------- */
  var STAGES = ["Ordered", "Shipped", "In transit", "Out for delivery", "Delivered"];
  var STAGE_ICONS = ["bag", "box", "truck", "pin", "home"];

  // technical status -> presentation. step = filled position in STAGES.
  var STATUS = {
    pending:          { step: 1, tone: "sky",     label: "Order received",   blurb: "Your label is ready \u2014 we're waiting for the carrier to collect your book." },
    info_received:    { step: 1, tone: "sky",     label: "Order received",   blurb: "Your label is ready \u2014 we're waiting for the carrier to collect your book." },
    in_transit:       { step: 2, tone: "sky",     label: "In transit",       blurb: "Your book is on its way to you." },
    out_for_delivery: { step: 3, tone: "sky",     label: "Out for delivery", blurb: "Your book is on the truck and arriving today." },
    delivered:        { step: 4, tone: "success", label: "Delivered",        blurb: "Your book has arrived. We hope you love every page." },
    exception:        { step: 2, tone: "error",   label: "Delivery issue",   blurb: "There's a hold-up with your delivery. The carrier needs an action to continue." },
    expired:          { step: 2, tone: "muted",   label: "Tracking expired", blurb: "This tracking number hasn't updated in a while and is no longer being tracked." },
  };
  function statusOf(key) { return STATUS[key] || STATUS.in_transit; }

  /* ---------- inline icons (no external font/CDN) ---------- */
  var ICON = {
    bag:    '<path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    box:    '<path d="M3 8 12 3l9 5v8l-9 5-9-5V8Z"/><path d="m3 8 9 5 9-5"/><path d="M12 13v8"/>',
    truck:  '<path d="M2 6h11v9H2zM13 9h4l3 3v3h-7z"/><circle cx="6.5" cy="17.5" r="1.6"/><circle cx="16.5" cy="17.5" r="1.6"/>',
    pin:    '<path d="M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11Z"/><circle cx="12" cy="10" r="2.4"/>',
    home:   '<path d="m4 11 8-7 8 7"/><path d="M6 10v9h12v-9"/>',
    check:  '<path d="M5 12.5 10 17l9-10"/>',
    alert:  '<path d="M12 4 2.5 20h19L12 4Z"/><path d="M12 10v4"/><path d="M12 17.5v.2"/>',
    search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
    arrow:  '<path d="M5 12h14M13 6l6 6-6 6"/>',
    copy:   '<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/>',
    book:   '<path d="M5 4h11a2 2 0 0 1 2 2v14H7a2 2 0 0 1-2-2V4Z"/><path d="M5 18a2 2 0 0 1 2-2h11"/>',
    help:   '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 0 1 4.5 1.5c0 1.7-2 2-2 3.2"/><path d="M12 17.5v.2"/>',
  };
  function svg(name, size, sw) {
    size = size || 20; sw = sw || 1.7;
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + sw + '" stroke-linecap="round" stroke-linejoin="round">' + (ICON[name] || "") + "</svg>";
  }

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  // parse "2026-06-07T14:42:00" (or date-only) without timezone surprises
  function parseDT(s) {
    if (!s) return null;
    var m = String(s).match(/(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
    if (!m) return null;
    return { y: +m[1], mo: +m[2], d: +m[3], h: m[4] != null ? +m[4] : null, mi: m[5] != null ? +m[5] : null };
  }
  function fmtDate(s) { var p = parseDT(s); return p ? MONTHS[p.mo - 1] + " " + p.d : "\u2014"; }
  function fmtDayLong(s) { var p = parseDT(s); return p ? MONTHS[p.mo - 1] + " " + p.d : ""; }
  function fmtTime(s) {
    var p = parseDT(s); if (!p || p.h == null) return "";
    var ap = p.h >= 12 ? "PM" : "AM", h = p.h % 12; if (h === 0) h = 12;
    return h + ":" + String(p.mi).padStart(2, "0") + " " + ap;
  }
  // normalise events to {datetime, location, description} newest-first
  function normEvents(events) {
    if (!Array.isArray(events)) return [];
    return events.map(function (e) {
      return {
        datetime: e.datetime || e.time || e.timestamp || "",
        location: e.location || e.loc || "",
        description: e.description || e.desc || e.message || "",
        exception: !!e.exception || /exception|fail|undeliver|return/i.test(e.description || ""),
      };
    });
  }
  function groupByDay(events) {
    var out = [], cur = null;
    events.forEach(function (e) {
      var day = fmtDayLong(e.datetime);
      if (!cur || cur.day !== day) { cur = { day: day, items: [] }; out.push(cur); }
      cur.items.push(e);
    });
    return out;
  }

  /* ============================================================
     RENDER: INITIAL (lookup form)
     ============================================================ */
  function renderInitial(prefill) {
    root.removeAttribute("data-tone");
    root.innerHTML =
      '<div class="mt-center" style="padding-top:8px">' +
        '<div class="mt-badge">' + svg("pin", 30, 1.8) + "</div>" +
        '<h1 style="font-size:clamp(30px,8vw,40px)">' + esc(CFG.heading) + "</h1>" +
        '<p class="mt-sub" style="max-width:320px;margin:10px auto 0">' + esc(CFG.sub) + "</p>" +
        '<form class="mt-form" novalidate>' +
          '<div class="mt-field">' + svg("search", 18) +
            '<input class="mt-input" type="text" inputmode="numeric" autocomplete="off" name="tracking" placeholder="e.g. 445379131732" value="' + esc(prefill || "") + '">' +
          "</div>" +
          '<div class="mt-input-err">Please enter a valid tracking number.</div>' +
          '<button type="submit" class="mt-btn mt-btn--grad mt-btn--block" style="margin-top:12px;padding:16px 36px;font-size:16px">Track my order</button>' +
        "</form>" +
        '<button type="button" class="mt-helper">' + svg("help", 15) + "Where do I find my tracking number?" +
          '<span class="mt-tip">' + esc(CFG.helper) + "</span>" +
        "</button>" +
        '<div class="mt-trust">' +
          ["Updated in real time", "All carriers, one page", "No account needed"].map(function (t) {
            return '<div><span class="mt-check">' + svg("check", 11, 3) + "</span>" + t + "</div>";
          }).join("") +
        "</div>" +
      "</div>";

    var form = root.querySelector(".mt-form");
    var input = root.querySelector(".mt-input");
    var err = root.querySelector(".mt-input-err");
    var helper = root.querySelector(".mt-helper");
    input.addEventListener("input", function () { input.classList.remove("is-error"); err.classList.remove("show"); });
    helper.addEventListener("click", function (e) { e.preventDefault(); root.querySelector(".mt-tip").classList.toggle("show"); });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = input.value.trim();
      if (v.length < 5) { input.classList.add("is-error"); err.classList.add("show"); return; }
      lookup(v);
    });
  }

  /* ============================================================
     RENDER: LOADING (skeleton)
     ============================================================ */
  function renderLoading() {
    root.removeAttribute("data-tone");
    function bar(w, h, mt) { return '<div class="mt-sk" style="width:' + w + ';height:' + (h || 14) + "px;margin-top:" + (mt || 0) + 'px"></div>'; }
    var steps = "";
    for (var i = 0; i < 5; i++) steps += '<div style="display:flex;flex-direction:column;align-items:center;gap:8px"><div class="mt-sk" style="width:38px;height:38px;border-radius:50%"></div>' + bar("40px", 8) + "</div>";
    var rows = "";
    for (var j = 0; j < 4; j++) rows += '<div style="display:flex;gap:14px;margin-bottom:20px"><div class="mt-sk" style="width:12px;height:12px;border-radius:50%;margin-top:3px;flex:0 0 12px"></div><div style="flex:1">' + bar((70 - j * 8) + "%", 14) + bar("40%", 11, 8) + "</div></div>";
    root.innerHTML =
      '<div style="padding-top:8px">' +
        '<div style="display:flex;flex-direction:column;align-items:center;gap:14px">' + bar("110px", 12) +
          '<div class="mt-sk" style="width:220px;height:44px;border-radius:10px"></div>' + bar("280px", 13) + "</div>" +
        '<div style="display:flex;justify-content:space-between;margin-top:34px">' + steps + "</div>" +
        '<hr class="mt-rule" style="margin:34px 0 24px">' + rows +
        '<div class="mt-center" style="font-size:13px;color:var(--mt-fg-3);letter-spacing:.04em">Fetching the latest updates\u2026</div>' +
      "</div>";
  }

  /* ============================================================
     RENDER: ERROR
     ============================================================ */
  function renderError(query) {
    root.removeAttribute("data-tone");
    root.innerHTML =
      '<div class="mt-center" style="padding-top:12px">' +
        '<div class="mt-badge mt-badge--err">' + svg("alert", 30, 1.8) + "</div>" +
        '<h1 style="font-size:clamp(26px,7vw,34px)">We couldn\'t find that order</h1>' +
        '<p class="mt-sub" style="max-width:340px;margin:10px auto 8px">' +
          (query ? "No tracking found for <strong style=\"color:var(--mt-ink)\">" + esc(query) + "</strong>." : "That tracking number didn't match any shipment.") + "</p>" +
        '<p style="max-width:340px;margin:0 auto 26px;color:var(--mt-fg-3);font-size:13.5px">Double-check the number from your shipping email \u2014 it can take up to 24h after dispatch for the first update to appear.</p>' +
        '<div style="display:flex;flex-direction:column;gap:10px;max-width:320px;margin:0 auto">' +
          '<button type="button" class="mt-btn mt-btn--grad mt-btn--block mt-retry" style="padding:16px 36px;font-size:16px">Try another number</button>' +
          '<a href="' + esc(CFG.supportUrl) + '" class="mt-btn mt-btn--ink mt-btn--block">Contact support</a>' +
        "</div>" +
      "</div>";
    root.querySelector(".mt-retry").addEventListener("click", function () { renderInitial(""); });
  }

  /* ============================================================
     RENDER: NEEDS POSTAL — some carriers (e.g. PostNL) require the
     destination country + postal code before they can be tracked.
     ============================================================ */
  function renderNeedsPostal(num) {
    root.removeAttribute("data-tone");
    root.innerHTML =
      '<div class="mt-center" style="padding-top:12px">' +
        '<div class="mt-badge">' + svg("pin", 30, 1.8) + "</div>" +
        '<h1 style="font-size:clamp(26px,7vw,34px)">One more detail</h1>' +
        '<p class="mt-sub" style="max-width:340px;margin:10px auto 18px">This carrier needs the delivery country and postal code to look up <strong style="color:var(--mt-ink)">' + esc(num) + "</strong>.</p>" +
        '<form class="mt-form mt-pc-form" novalidate style="max-width:320px;margin:0 auto">' +
          '<div class="mt-field"><input class="mt-input mt-cc" type="text" autocomplete="country" maxlength="2" placeholder="Country (e.g. NL)" style="text-transform:uppercase"></div>' +
          '<div class="mt-field" style="margin-top:10px"><input class="mt-input mt-pc" type="text" autocomplete="postal-code" placeholder="Postal code (e.g. 1000 AA)"></div>' +
          '<div class="mt-input-err">Please enter a 2-letter country and postal code.</div>' +
          '<button type="submit" class="mt-btn mt-btn--grad mt-btn--block" style="margin-top:12px;padding:16px 36px;font-size:16px">Track my order</button>' +
        "</form>" +
        '<button type="button" class="mt-btn mt-btn--ink mt-btn--block mt-reset" style="max-width:320px;margin:10px auto 0">← Track a different order</button>' +
      "</div>";
    var form = root.querySelector(".mt-pc-form");
    var cc = root.querySelector(".mt-cc");
    var pc = root.querySelector(".mt-pc");
    var err = root.querySelector(".mt-input-err");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var c = cc.value.trim().toUpperCase();
      var p = pc.value.trim();
      if (!/^[A-Z]{2}$/.test(c) || p.length < 2) { err.classList.add("show"); return; }
      lookup(num, { cc: c, pc: p });
    });
    root.querySelector(".mt-reset").addEventListener("click", function () {
      history.replaceState(null, "", location.pathname);
      renderInitial("");
    });
  }

  /* ============================================================
     RENDER: RESULT
     ============================================================ */
  function renderResult(data) {
    var s = statusOf(data.status);
    var tone = s.tone;
    root.setAttribute("data-tone", tone);
    var events = normEvents(data.events);
    var label = data.status_label || s.label;
    var ordered = data.ordered_at;
    var delivered = data.delivered_at;
    var eta = data.estimated_delivery || data.eta || null;

    // second date chip
    var rightLbl, rightVal;
    if (data.status === "delivered" && delivered) { rightLbl = "Delivered"; rightVal = fmtDate(delivered); }
    else if (eta) { rightLbl = "Estimated delivery"; rightVal = fmtDate(eta); }
    else if (events[0]) { rightLbl = "Latest update"; rightVal = fmtDate(events[0].datetime); }
    else { rightLbl = "Status"; rightVal = label; }

    /* stepper */
    var stepper = "";
    for (var i = 0; i < STAGES.length; i++) {
      var done = i < s.step || (s.step === 4 && i === 4);
      var current = i === s.step && s.step !== 4;
      var filled = i <= s.step;
      var inner = (done && tone !== "error") ? svg("check", 18, 2.4)
        : (tone === "error" && current) ? '<span style="font-weight:800;font-size:18px;line-height:1">!</span>'
        : svg(STAGE_ICONS[i], 18, 1.9);
      var nodeBg = filled ? toneVar(tone) : "";
      stepper +=
        '<div class="mt-step ' + (done ? "is-done " : "") + (current ? "is-current" : "") + '">' +
          '<div class="mt-node ' + (filled ? "is-filled " : "") + (current ? "is-current" : "") + '"' +
            (filled ? ' style="background:' + nodeBg + '"' : "") + ">" + inner + "</div>" +
          '<div class="mt-step-lbl">' + STAGES[i] + "</div>" +
        "</div>";
      if (i < STAGES.length - 1) {
        stepper += '<div class="mt-conn"' + (i < s.step ? ' style="background:' + toneVar(tone) + '"' : "") + "></div>";
      }
    }

    /* timeline */
    var groups = groupByDay(events);
    var collapsible = events.length > 5, shown = 0;
    var tl = groups.map(function (g) {
      var items = g.items.filter(function () { if (!collapsible) return true; shown++; return shown <= 4; });
      if (!items.length) return "";
      return '<div style="margin-bottom:4px"><div class="mt-day">' + g.day + "</div>" +
        items.map(function (e, idx) {
          var latest = (g === groups[0]) && idx === 0 && g.items[0] === e && events[0] === e;
          return '<div class="mt-ev ' + (latest ? "is-latest" : "") + '">' +
            '<div class="mt-rail"><div class="mt-dot ' + (e.exception ? "is-exception" : "") + '"></div></div>' +
            '<div class="mt-ev-body"><div class="mt-ev-desc ' + (e.exception ? "is-exception" : "") + '">' + esc(e.description) + "</div>" +
              '<div class="mt-ev-meta">' + (e.location ? "<span>" + esc(e.location) + "</span><span class=\"mt-dotsep\">\u00b7</span>" : "") +
                "<span>" + fmtTime(e.datetime) + "</span></div></div></div>";
        }).join("") + "</div>";
    }).join("");
    var toggle = collapsible ? '<button type="button" class="mt-toggle" aria-expanded="false">Show all ' + events.length + ' updates <span class="mt-caret">\u25be</span></button>' : "";

    var alert = (tone === "error")
      ? '<div class="mt-alert">' + svg("alert", 20) + "<div>Action needed \u2014 please confirm your delivery address with the carrier, or contact our support and we'll sort it out.</div></div>"
      : "";

    var xsell = CFG.xsell
      ? '<div class="mt-xsell"><div class="mt-xsell-row"><div class="mt-xsell-ico">' + svg("book", 22, 1.8) + "</div>" +
        '<div style="flex:1;min-width:0"><div class="mt-xsell-h">' + esc(CFG.xsellH) + '</div><div class="mt-xsell-p">' + esc(CFG.xsellP) + "</div></div></div>" +
        '<a href="' + esc(CFG.xsellUrl) + '" class="mt-btn mt-btn--grad mt-btn--sm mt-btn--block">' + esc(CFG.xsellBtn) + "</a></div>"
      : "";

    root.innerHTML =
      alert +
      '<div class="mt-center">' +
        '<div class="mt-eyebrow">Order \u00b7 ' + esc(data.order_number || URL_ORDER || data.tracking_number) + "</div>" +
        '<h1 class="mt-status-word">' + esc(label) + "</h1>" +
        '<p class="mt-sub" style="max-width:360px;margin:12px auto 0">' + esc(s.blurb) + "</p>" +
        '<div class="mt-dates">' +
          '<div class="mt-date"><div class="mt-date-lbl">Ordered</div><div class="mt-date-val">' + fmtDate(ordered) + "</div></div>" +
          '<div class="mt-date"><div class="mt-date-lbl">' + rightLbl + '</div><div class="mt-date-val mt-eta-val">' + rightVal + "</div></div>" +
        "</div>" +
      "</div>" +
      '<div class="mt-stepper">' + stepper + "</div>" +
      '<hr class="mt-rule">' +
      '<div class="mt-section-title">Shipping details</div>' +
      '<div class="mt-timeline">' + (tl || '<p class="mt-sub">No tracking events yet.</p>') + toggle + "</div>" +
      '<hr class="mt-rule">' +
      '<div class="mt-section-title">Carrier</div>' +
      '<div class="mt-carrier">' +
        '<div class="mt-carrier-chip">' + esc(data.carrier || "Carrier") + "</div>" +
        '<div class="mt-carrier-info"><div class="mt-carrier-lbl">Tracking number</div>' +
          (data.carrier_tracking_url
            ? '<a class="mt-carrier-num" href="' + esc(data.carrier_tracking_url) + '" target="_blank" rel="noreferrer">' + esc(data.tracking_number) + svg("arrow", 14, 2) + "</a>"
            : '<span class="mt-carrier-num">' + esc(data.tracking_number) + "</span>") +
        "</div></div>" +
      '<div class="mt-actions">' +
        '<button type="button" class="mt-btn mt-btn--ghost mt-btn--sm mt-copy">' + svg("copy", 15, 2) + "Copy link</button>" +
        (data.carrier_tracking_url
          ? '<a href="' + esc(data.carrier_tracking_url) + '" target="_blank" rel="noreferrer" class="mt-btn mt-btn--grad mt-btn--sm">' + esc(data.carrier || "Carrier") + " site" + svg("arrow", 15, 2) + "</a>"
          : "") +
      "</div>" +
      xsell +
      '<div class="mt-center"><button type="button" class="mt-reset">\u2190 Track a different order</button></div>';

    /* wire interactions */
    if (toggle) {
      var tBtn = root.querySelector(".mt-toggle");
      tBtn.addEventListener("click", function () {
        var expanded = tBtn.getAttribute("aria-expanded") === "true";
        // re-render timeline fully / collapsed
        renderResult(Object.assign({}, data, { __expanded: !expanded }));
        if (!expanded) { /* expanded handled below via flag */ }
      });
    }
    // expansion: if flagged, replace timeline with all events
    if (data.__expanded) {
      var full = groups.map(function (g) {
        return '<div style="margin-bottom:4px"><div class="mt-day">' + g.day + "</div>" +
          g.items.map(function (e, idx) {
            var latest = (g === groups[0]) && idx === 0;
            return '<div class="mt-ev ' + (latest ? "is-latest" : "") + '"><div class="mt-rail"><div class="mt-dot ' + (e.exception ? "is-exception" : "") + '"></div></div>' +
              '<div class="mt-ev-body"><div class="mt-ev-desc ' + (e.exception ? "is-exception" : "") + '">' + esc(e.description) + "</div>" +
              '<div class="mt-ev-meta">' + (e.location ? "<span>" + esc(e.location) + "</span><span class=\"mt-dotsep\">\u00b7</span>" : "") + "<span>" + fmtTime(e.datetime) + "</span></div></div></div>";
          }).join("") + "</div>";
      }).join("");
      root.querySelector(".mt-timeline").innerHTML = full +
        '<button type="button" class="mt-toggle" aria-expanded="true">Show less <span class="mt-caret">\u25be</span></button>';
      root.querySelector(".mt-toggle").addEventListener("click", function () { renderResult(Object.assign({}, data, { __expanded: false })); });
    }

    var copyBtn = root.querySelector(".mt-copy");
    if (copyBtn) copyBtn.addEventListener("click", function () {
      var sp = new URLSearchParams();
      sp.set("tnr", data.tracking_number);
      if (URL_ORDER) sp.set("order", URL_ORDER);
      if (URL_CC) sp.set("cc", URL_CC);
      if (URL_PC) sp.set("pc", URL_PC);
      var url = location.origin + location.pathname + "?" + sp.toString();
      try { navigator.clipboard.writeText(url); } catch (e) {}
      copyBtn.innerHTML = svg("check", 15, 2) + "Link copied";
      setTimeout(function () { copyBtn.innerHTML = svg("copy", 15, 2) + "Copy link"; }, 1800);
    });
    var resetBtn = root.querySelector(".mt-reset");
    if (resetBtn) resetBtn.addEventListener("click", function () {
      history.replaceState(null, "", location.pathname);
      renderInitial("");
    });
  }

  function toneVar(t) { return t === "success" ? "var(--mt-success)" : t === "error" ? "var(--mt-error)" : t === "muted" ? "var(--mt-fg-3)" : "var(--mt-sky)"; }

  /* ============================================================
     DATA: fetch or demo
     ============================================================ */
  function lookup(num, dest) {
    // Keep the number in the URL for refresh/share, but preserve the email link's
    // order/cc/pc so a reload (or shared link) can still track carriers that need
    // a postal code (PostNL, etc.). Only tnr is rewritten.
    var sp = new URLSearchParams(location.search);
    sp.set("tnr", num);
    sp.delete("nums"); // normalise the legacy Track123 param
    if (dest && dest.cc) sp.set("cc", dest.cc);
    if (dest && dest.pc) sp.set("pc", dest.pc);
    history.replaceState(null, "", location.pathname + "?" + sp.toString());
    renderLoading();
    if (CFG.demo) {
      setTimeout(function () {
        if (/0$/.test(num)) { renderError(num); }
        else { renderResult(demoData(num)); }
      }, 1100);
      return;
    }
    if (!CFG.endpoint) { renderError(num); return; }
    var url = CFG.endpoint + (CFG.endpoint.indexOf("?") > -1 ? "&" : "?") + "tracking_number=" + encodeURIComponent(num);
    // Destination (country + postal) for carriers that require it (e.g. PostNL),
    // from the email link (?cc=&pc=) or the "needs postal" prompt.
    var cc = (dest && dest.cc) || URL_CC;
    var pc = (dest && dest.pc) || URL_PC;
    if (cc && pc) { url += "&country=" + encodeURIComponent(cc) + "&postal_code=" + encodeURIComponent(pc); }
    var headers = { Accept: "application/json" };
    if (CFG.apiKey) { headers["X-API-KEY"] = CFG.apiKey; }
    fetch(url, { headers: headers })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        if (!data || !data.tracking_number || !data.status) { renderError(num); return; }
        if (data.status === "needs_postal") { renderNeedsPostal(num); return; }
        renderResult(data);
      })
      .catch(function () { renderError(num); });
  }

  /* sample payload for demo_mode / the /pages/tracking-dev page */
  function demoData(num) {
    return {
      order_number: "MB582918",
      tracking_number: num || "445379131732",
      carrier: "FedEx",
      carrier_code: "fedex",
      carrier_tracking_url: "https://www.fedex.com/fedextrack/?trackingnumber=" + (num || "445379131732"),
      status: "out_for_delivery",
      status_label: "Out for delivery",
      ordered_at: "2026-05-31",
      delivered_at: null,
      estimated_delivery: "2026-06-08",
      last_location: "San Diego, CA, US",
      events: [
        { datetime: "2026-06-07T07:46", location: "San Diego, CA, US",    description: "On FedEx vehicle for delivery" },
        { datetime: "2026-06-07T07:22", location: "San Diego, CA, US",    description: "At local FedEx facility" },
        { datetime: "2026-06-07T02:10", location: "City of Industry, CA", description: "Departed FedEx location" },
        { datetime: "2026-06-06T18:56", location: "City of Industry, CA", description: "Arrived at FedEx location" },
        { datetime: "2026-06-06T17:24", location: "Walnut, CA, US",       description: "In transit" },
        { datetime: "2026-06-05T22:56", location: "Tehama, CA, US",       description: "In transit" },
        { datetime: "2026-06-05T10:51", location: "Troutdale, OR, US",    description: "Left FedEx origin facility" },
        { datetime: "2026-06-05T06:52", location: "Troutdale, OR, US",    description: "Arrived at FedEx location" },
        { datetime: "2026-06-04T22:28", location: "Auburn, WA, US",       description: "Left FedEx origin facility" },
        { datetime: "2026-06-04T12:58", location: "United States",        description: "Shipment information sent to FedEx" },
        { datetime: "2026-05-31T11:32", location: "",                     description: "Order placed" }
      ]
    };
  }

  /* ============================================================
     INIT — prefill from ?tnr= (MSB) or ?nums= (legacy Track123)
     ============================================================ */
  function init() {
    var p = new URLSearchParams(location.search);
    var pre = p.get("tnr") || p.get("nums") || "";
    URL_ORDER = p.get("order") || ""; // optional order code from the email link
    URL_CC = (p.get("cc") || "").trim().toUpperCase();
    URL_PC = (p.get("pc") || "").trim();
    if (pre) { renderInitial(pre); lookup(pre); }
    else { renderInitial(""); }
  }
  init();
})();
